import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import PropTypes from "prop-types";

const DashboardCard = ({ data, title, icon, color, percentage }) => {
  return (
    <Grid item xs={12} md={6} lg={3}>
      <MDBox mb={1.5}>
        <ComplexStatisticsCard
          color={color}
          icon={icon}
          title={title}
          count={data}
          percentage={percentage}
        />
      </MDBox>
    </Grid>
  );
};

export default DashboardCard;

DashboardCard.propTypes = {
  percentage: PropTypes.object,
  icon: PropTypes.string,
  color: PropTypes.string,
  title: PropTypes.string,
  data: PropTypes.object,
};
